import {Component, Input, OnInit} from '@angular/core';

interface IDonutChartDataItem {
    label: string;
    value: number;
    color?: string;

    startAngle?: number;
    endAngle?: number;
    d?: string;
}

interface IDonutChartOptions {
    radius?: number;
    outerRadius?: number;
    innerRadius?: number;
}

@Component({
    selector: 'donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.css']
})
export class DonutChartComponent implements OnInit {

    @Input() data: IDonutChartDataItem[];
    @Input() options: IDonutChartOptions;
    arcs: any[];

    constructor() {
        this.data = [
            {
                label: 'Internal',
                value: 123,
                color: '#0088ff'
            },
            {
                label: 'External',
                value: 456,
                color: '#ff8800'
            }
        ];

        this.options = {
            radius: 100,
            outerRadius: 100,
            innerRadius: 80
        };
    }

    ngOnInit() {
    }

    createArcs() {

        const self = this;
        const cx = self.options.radius;
        const cy = self.options.radius;

        const totalValue = this.data.reduce((sum, item) => {
            return sum = sum + item.value;
        }, 0);

        let cumulativeAngle = 0;
        for (let item of this.data) {
            let angle = 360 * (item.value / totalValue);

            item.startAngle = cumulativeAngle;
            item.endAngle = cumulativeAngle + angle;

            cumulativeAngle = item.endAngle;

            item.d = self.describeArc(cx, cy, self.options.radius, item.startAngle, item.endAngle);
        }
    }

    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        const self = this;
        let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    }

    describeArc(x, y, radius, startAngle, endAngle) {

        let start = this.polarToCartesian(x, y, radius, endAngle);
        let end = this.polarToCartesian(x, y, radius, startAngle);

        let largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

        // this is the value of the d attribute of the path
        return [
            'M', start.x, start.y,
            'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y
        ].join(' ');
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/donut-chart/donut-chart.component.ts